import React, {Component} from 'react';
import './App.css';
import MusicAlgoNav from '../MusicAlgoNav';
import MusicAlgoFooter from '../MusicAlgoFooter';
import {Jumbotron} from 'react-bootstrap';


class App404 extends Component {

  render() {
    return (
      <div className="App">
        <div className="cont">
        <Jumbotron style={{marginBottom:"0"}}>
            <h1 class="titleHeader">Error 404</h1>
        </Jumbotron>
            <p style={{ marginTop:"70px",
                        fontSize:"3rem", 
                        fontWeight:"400",
                        textAlign:"center" }}> 
                The page you were looking for could not be found.
            </p>
        </div>
       </div>
    );
  }
}

export default App404;



// WEBPACK FOOTER //
// ./src/App404/App404.js